import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GET_OVERVIEW_TABLE_DATA } from "../../../redux/constants";
import NotificationModal from "./NotificationModal";

// Adding new tooltip
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
import { getOverviewSummaryCount } from "../../../redux/actions/overview";
import { useEffect } from "react";

export const OverviewCard = (props) => {
  const {
    company_id,
    email,
    updateTable,
    isEmbedded,
    viewType,
    handleViewType,
    children,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const { type } = useSelector(state => state.auth);

  const getOverviewSummary = () => {
    const request = {
      onError: () => {},
      onSuccess: () => {},
    };
    dispatch(getOverviewSummaryCount(request));
  };

  useEffect(() => {
    getOverviewSummary();
  }, [updateTable]);

  return (
    <div className="w-full h-full bg-white mt-4">
      <div className="sm:mb-0 flex justify-between items-center">
        <div className="space-x-4 flex justify-between items-center">
          <h4
            className="text-[--bg-color-500] cursor-pointer font-semibold text-xs leading-[100%]"
            onClick={props.handleExport}
          >
            Export
            <span className="fa-solid fa-arrow-down-to-bracket ml-2"></span>
          </h4>
          {!["customer", "collaborator", "user"].includes(type) && (
            <h4
              className="text-[--bg-color-500] cursor-pointer font-semibold text-xs leading-[100%]"
              onClick={() => setOpenNotificationModal(true)}
            >
              Remind Assigned Users
              <span className="fa-solid fa-arrow-right ml-2"></span>
            </h4>
          )}
        </div>
        <div className="flex justify-between items-center space-x-4">
          <Tippy content="List View">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              className="w-4 h-4 cursor-pointer outline-none"
              onClick={() => {
                handleViewType("list");
                dispatch({ type: GET_OVERVIEW_TABLE_DATA, payload: [] });
                !isEmbedded
                  ? navigate("/")
                  : navigate(`/dashboard/embedded/${company_id}/${email}`);
              }}
            >
              <path
                className={`${
                  viewType === "list"
                    ? "fa-primary text-[--bg-color-500]"
                    : "fa-primary text-slate-600"
                }`}
                fill="currentColor"
                d="M16 72C16 58.75 26.75 48 40 48H88C101.3 48 112 58.75 112 72V120C112 133.3 101.3 144 88 144H40C26.75 144 16 133.3 16 120V72zM16 232C16 218.7 26.75 208 40 208H88C101.3 208 112 218.7 112 232V280C112 293.3 101.3 304 88 304H40C26.75 304 16 293.3 16 280V232zM88 368C101.3 368 112 378.7 112 392V440C112 453.3 101.3 464 88 464H40C26.75 464 16 453.3 16 440V392C16 378.7 26.75 368 40 368H88z"
              />
              <path
                className={`${
                  viewType === "list"
                    ? "fa-secondary text-[--bg-color-500]"
                    : "fa-secondary text-slate-300"
                }`}
                fill="currentColor"
                d="M160 96C160 78.33 174.3 64 192 64H480C497.7 64 512 78.33 512 96C512 113.7 497.7 128 480 128H192C174.3 128 160 113.7 160 96zM160 256C160 238.3 174.3 224 192 224H480C497.7 224 512 238.3 512 256C512 273.7 497.7 288 480 288H192C174.3 288 160 273.7 160 256zM480 384C497.7 384 512 398.3 512 416C512 433.7 497.7 448 480 448H192C174.3 448 160 433.7 160 416C160 398.3 174.3 384 192 384H480z"
              />
            </svg>
          </Tippy>
          <Tippy content="Calendar View">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4 cursor-pointer outline-none"
              viewBox="0 0 448 512"
              onClick={() => {
                handleViewType("calendar");
                dispatch({ type: GET_OVERVIEW_TABLE_DATA, payload: [] });
              }}
            >
              <path
                className={`${
                  viewType === "calendar"
                    ? "fa-primary text-[--bg-color-600]"
                    : "fa-primary text-slate-600"
                }`}
                fill="currentColor"
                d="M160 64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V192H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32V64z"
              />
              <path
                className={`${
                  viewType === "calendar"
                    ? "fa-secondary text-[--bg-color-400]"
                    : "fa-secondary text-slate-300"
                }`}
                fill="currentColor"
                d="M0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192z"
              />
            </svg>
          </Tippy>
        </div>
      </div>
      <div className="mt-4 space-y-6">
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <div className="h-[90px] bg-[--bg-color-50] rounded flex justify-center items-center">
            <div className="w-[80%]">
              <div>
                <span className="text-[#2F80ED] text-2xl leading-6 font-semibold">
                  {overviewSummaryCount.total}
                </span>
                <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
                  &nbsp;To Do
                </span>
              </div>
              <p className="text-[#313439] text-sm leading-3 font-medium">
                in Total
              </p>
            </div>
          </div>
          <div className="h-[90px] bg-[--bg-color-50] rounded flex justify-center items-center">
            <div className="w-[80%]">
              <div>
                <span className="text-[#2F80ED] text-2xl leading-6 font-semibold">
                  {overviewSummaryCount.isProgress}
                </span>
                <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
                  &nbsp;To Do
                </span>
              </div>
              <p className="text-[#313439] text-sm leading-3 font-medium">
                in Progress
              </p>
            </div>
          </div>
          <div className="h-[90px] bg-[--bg-color-50] rounded flex justify-center items-center">
            <div className="w-[80%]">
              <div>
                <span className="text-[#2F80ED] text-2xl leading-6 font-semibold">
                  {overviewSummaryCount.Pending}
                </span>
                <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
                  &nbsp;To Do
                </span>
              </div>
              <p className="text-[#313439] text-sm leading-3 font-medium">
                Pending
              </p>
            </div>
          </div>
          <div className="h-[90px] bg-[--bg-color-50] rounded flex justify-center items-center">
            <div className="w-[80%]">
              <div>
                <span className="text-[#2F80ED] text-2xl leading-6 font-semibold">
                  {overviewSummaryCount.Overdue}
                </span>
                <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
                  &nbsp;To Do
                </span>
              </div>
              <p className="text-[#313439] text-sm leading-3 font-medium">
                Overdue
              </p>
            </div>
          </div>
          <div className="h-[90px] bg-[--bg-color-50] rounded flex justify-center items-center">
            <div className="w-[80%]">
              <div>
                <span className="text-[#2F80ED] text-2xl leading-6 font-semibold">
                  {overviewSummaryCount.Completed}
                </span>
                <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
                  &nbsp;To Do
                </span>
              </div>
              <p className="text-[#313439] text-sm leading-3 font-medium">
                Completed
              </p>
            </div>
          </div>
        </div> */}
        {children}
      </div>

      {/* Notification Modal Pop-up */}
      <NotificationModal
        openNotificationModal={openNotificationModal}
        setOpenNotificationModal={setOpenNotificationModal}
        handleNotificationData={props.handleNotificationData}
        notificationLoader={props.notificationLoader}
      />
    </div>
  );
};
